import { useCallback } from 'react';
import { apiClient } from 'core/utils/apiClient';
import { useCurrentUserEmsTeam } from '../../hooks/useCurrentUserEmsTeam';

export const useMessageDelete = (onDeleteSuccess?: () => void) => {
  const { emsTeam } = useCurrentUserEmsTeam();

  // メッセージを削除
  const deleteMessage = useCallback(async (messageId: string): Promise<boolean> => {
    if (!emsTeam?.emsTeamId) {
      console.error('EMSチーム情報が取得できませんでした');
      return false;
    }

    try {
      await apiClient.delete(`/ems-teams/${emsTeam.emsTeamId}/messages/${messageId}`);

      // 削除成功後のコールバック実行
      if (onDeleteSuccess) {
        onDeleteSuccess();
      }
      
      return true;
    } catch (err) {
      console.error('メッセージ削除エラー:', err);
      return false;
    }
  }, [emsTeam?.emsTeamId, onDeleteSuccess]);

  // 確認ダイアログ付きでメッセージを削除
  const deleteMessageWithConfirm = useCallback(async (messageId: string) => {
    if (!window.confirm('このメッセージを削除しますか？')) {
      return;
    }

    const success = await deleteMessage(messageId);
    if (!success) {
      alert('メッセージの削除に失敗しました');
    }
  }, [deleteMessage]);

  return {
    deleteMessage: deleteMessageWithConfirm,
    deleteMessageDirectly: deleteMessage
  };
}; 